/*!

=========================================================
* Argon Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// core styles
import "assets/css/util.css";
import "assets/scss/argon-dashboard-pro-react.scss?v1.0.0";
import "assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
// plugins styles downloaded
import "assets/vendor/fullcalendar/dist/fullcalendar.min.css";
import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/quill/dist/quill.core.css";
import "assets/vendor/select2/dist/css/select2.min.css";
import "assets/vendor/sweetalert2/dist/sweetalert2.min.css";
import AdminLayout from "layouts/Admin.jsx";
import AuthLayout from "layouts/Auth.jsx";
import SuperAdminLayout from "layouts/SuperAdmin.jsx";
import React from "react";
import ReactDOM from "react-dom";
// plugins styles from node_modules
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import {Provider} from "react-redux";
// react library for routing
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import IndexView from "views/Index.jsx";
import ProtectedRoute from "./components/auth/ProtectedRoute.jsx";
import "./i18n";
import StatusPageLayout from "./layouts/Status.jsx";
import store from "./store/configureStore";
import xareGrowthProtectedRoutes from "./xareGrowthProtectedRoutes";
import Blog from "./views/Blog";
import KnowledgeCentre2 from "./views/KnowledgeCentre2";
import AboutUs from "./views/AboutUs";
import VersionChecker from "./views/pages/util/VersionChecker";
import Pricing from "./views/Pricing";
import subscribedUserProtectedRoutes from "./subscribedUserProtectedRoutes";
import ReviewSubmission from "./views/ReviewSubmission";
import XareView from "./views/XareView";

ReactDOM.render(
    <Provider store={store}>
        <VersionChecker/>
        <BrowserRouter>
            <Switch>
                <ProtectedRoute
                    requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"]}
                    redirectToPath="/"
                    path="/admin/dashboard"
                    component={(props) => <AdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_ADMIN", "ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN"]}
                    redirectToPath="/"
                    path="/admin/list"
                    // requiredPermissionList={[AdminPermissionType.LIST_ADMIN]}
                    component={(props) => <AdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN"]}
                    redirectToPath="/"
                    path="/admin/create"
                    // requiredPermissionList={[AdminPermissionType.CREATE_ADMIN]}
                    component={(props) => <AdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_ADMIN"]}
                    redirectToPath="/"
                    path="/admin/show/:uniqueId"
                    // requiredPermissionList={[AdminPermissionType.READ_ADMIN]}
                    component={(props) => <AdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN", "ROLE_TENANT_ADMIN"]}
                    redirectToPath="/"
                    path="/admin/edit/:uniqueId"
                    // requiredPermissionList={[AdminPermissionType.UPDATE_ADMIN]}
                    component={(props) => <AdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/superAdmin/dashboard"
                    component={(props) => <SuperAdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/superAdmin/tenant/list"
                    component={(props) => <SuperAdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/superAdmin/tenant/admin/create/:tenantUID"
                    component={(props) => <SuperAdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/superAdmin/tenant/configuration/:tenantUID"
                    component={(props) => <SuperAdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/superAdmin/tenant/admin/show/:adminUID"
                    component={(props) => <SuperAdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/superAdmin/tenant/create"
                    component={(props) => <SuperAdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/superAdmin/tenant/show/:uniqueId"
                    component={(props) => <SuperAdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/superAdmin/tenant/edit/:uniqueId"
                    component={(props) => <SuperAdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_ADMIN", "ROLE_TENANT_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/admin/message/list"
                    component={(props) => <AdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_ADMIN", "ROLE_TENANT_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/admin/message/create"
                    component={(props) => <AdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_ADMIN", "ROLE_TENANT_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/admin/message/show/:uniqueId"
                    component={(props) => <AdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_ADMIN", "ROLE_TENANT_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/admin/message/edit/:uniqueId"
                    component={(props) => <AdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_TENANT_ADMIN"]}
                    redirectToPath="/auth/login"
                    path="/admin/tenantSetting/list"
                    component={(props) => <AdminLayout {...props} />}
                />
                <ProtectedRoute
                    requiredRoleList={["ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_TENANT_ADMIN", "ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"]}
                    redirectToPath="/auth/login"
                    path="/admin/settings"
                    component={(props) => <AdminLayout {...props} />}
                />


                {xareGrowthProtectedRoutes.map((route) => route)}
                {subscribedUserProtectedRoutes.map((route) => route)}
                <Route path="/auth/login" render={(props) => <AuthLayout {...props} />}/>
                <Route
                    path="/status/500"
                    render={(props) => <StatusPageLayout {...props} />}
                />
                <Route
                    path="/status/404"
                    render={(props) => <StatusPageLayout {...props} />}
                />
                <Route
                    path="/status/403"
                    render={(props) => <StatusPageLayout {...props} />}
                />
                <Route exact path="/" render={(props) => <IndexView {...props} />}/>
                <Route exact path="/knowledgeCentre" render={(props) => <KnowledgeCentre2 {...props} />}/>
                <Route exact path="/aboutUs" render={(props) => <AboutUs {...props} />}/>
                <Route exact path="/pricing" render={(props) => <Pricing {...props} />}/>
                <Route exact path="/xareview" render={(props) => <XareView {...props} />}/>
                <Route exact path="/review/:uniqueId" render={(props) => <ReviewSubmission {...props} />}/>
                <Route path="/blog/:uniqueId" render={(props) => <Blog {...props} />}/>
                <Redirect from="*" to="/status/404"/>
            </Switch>
        </BrowserRouter>
    </Provider>,
    document.getElementById("root")
);
